// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitPrimaryExhibitItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprGoods: cc.Sprite = null;


    start () {
        this.initUI();
    }

    initUI() {
        let goodsId = this._carryData.goodsId;
        let csvInfo = CsvDataManage.instance.getCsvDataItem(
            CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY_EXHIBIT, goodsId);
        if (!csvInfo) {
            console.error(`未找到表格数据`);
            return;
        }
        this.labelName.string = csvInfo.name;

        this.sprGoods.node.active = false;
        let iconPath = "res/primary/exhibit/" + csvInfo.icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.settleLawsuitBundle).load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprGoods.node.active = true;
                    this.sprGoods.spriteFrame = imgs;
                }
            }
        );
    }

    // update (dt) {}
}
